import Icon from "./Icon";

interface ProjectCardProps {
  title: string;
  text: string;
  image: string;
  technologies: string;
  credentials?: boolean;
  live?: string;
  code?: string;
}

export default function ProjectCard({
  title,
  text,
  image,
  technologies,
  credentials,
  live,
  code,
}: ProjectCardProps) {
  return (
    <article className="proj-card">
      <div className="proj-media">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="proj-body">
        <div className="proj-head">
          <h3>{title}</h3>
        </div>
        <p className="proj-text">{text}</p>
        {credentials && (
          <p className="proj-creds">
            <span>user</span> iolivera@dev.com&nbsp;&nbsp;·&nbsp;&nbsp;
            <span>pass</span> iolivera.dev
          </p>
        )}
        <div className="proj-tags">
          {technologies.split(" ").map((w, i) => (
            <span key={i} className="tag">
              {w}
            </span>
          ))}
        </div>
        <div className="proj-links">
          {live && (
            <a href={live} target="_blank" rel="noreferrer" className="proj-link primary">
              Go to site <Icon name="arrow" style={{ width: 15, height: 15 }} />
            </a>
          )}
          {code && (
            <a href={code} target="_blank" rel="noreferrer" className="proj-link">
              <Icon name="github" style={{ width: 16, height: 16 }} /> Code
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
